import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { fetchPaginatedInvestigationLogs } from "security-app/hooks/api/investigationsAPI";
import { investigationDrawerLogsQueryKey } from "security-app/hooks/queryKeys";
const DEFAULT_FETCH_ERROR = "Failed to load logs.";
const usePaginatedInvestigationLogs = ({
  investigationId,
  investigationUpdatedAt,
  currentPage,
  pageSize,
  fallbackTotal
}) => {
  var _a, _b, _c;
  const {
    data: logsResponse,
    isLoading: loadingLogs,
    isError: isLogsError,
    error: logsError
  } = useQuery({
    queryKey: investigationDrawerLogsQueryKey(investigationId, investigationUpdatedAt, currentPage, pageSize),
    queryFn: () => fetchPaginatedInvestigationLogs(investigationId, currentPage, pageSize),
    placeholderData: keepPreviousData,
    retry: false
  });
  const logs = (_a = logsResponse == null ? void 0 : logsResponse.elements) != null ? _a : [];
  const totalLogs = (_c = (_b = logsResponse == null ? void 0 : logsResponse.pagination) == null ? void 0 : _b.total) != null ? _c : fallbackTotal;
  const fetchError = logsError instanceof Error ? logsError.message : DEFAULT_FETCH_ERROR;
  const hasLoadedLogs = !!logsResponse;
  return {
    logs,
    totalLogs,
    loadingLogs,
    isLogsError,
    fetchError,
    hasLoadedLogs
  };
};
export default usePaginatedInvestigationLogs;
